// see also go functions in api/lib/xflow package
// these libraries have native browser equivalents,
// such as TextDecoder() instead of strFromU8 (frontend safeParseJson)
// and Blob methods for base64 stuff (frontend ldb.test.ts, FormrenderMount)
// but we want to use these functions from within v8go

import { fromUint8Array as b64Enc, toUint8Array as b64Dec } from 'js-base64'
import { gzipSync, gunzipSync, strToU8, strFromU8 } from 'fflate'
import { err, ok, type Result } from 'neverthrow'
import { serializeFusionError, type FusionError } from '../error/FusionError'

// compress on mac CLI:
// gzip -c item.csv | base64 | fold -w80 > item.csv.gz.b64
export const xflowBlobCompress = (blob: string): Result<string, FusionError> => {
	try {
		return ok(b64Enc(gzipSync(strToU8(blob))))
	} catch(ex) {
		return err(serializeFusionError('xflowBlobCompress', ex))
	}
}

// decompress on mac CLI:
// base64 -d -i item.csv.gz.b64 | gunzip > item.csv
export const xflowBlobDecompress = (b64GzBlob: string): Result<string, FusionError> => {
	try {
		return ok(strFromU8(gunzipSync(b64Dec(b64GzBlob))))
	} catch(ex) {
		return err(serializeFusionError('xflowBlobDecompress', ex))
	}
}
